const h = {
  small: {
    width: "14px",
    height: "14px"
  },
  medium: {
    width: "16px",
    height: "16px"
  },
  large: {
    width: "20px",
    height: "20px"
  },
  xlarge: {
    width: "24px",
    height: "24px"
  },
  fill: {
    width: "100%",
    height: "100%"
  }
};
export {
  h as iconSizeMap
};
